import React, { PureComponent } from 'react'
import styled from 'styled-components/native'
import { View, Platform } from 'react-native'
import { BarChart, XAxis } from 'react-native-svg-charts'
import * as Svg from 'react-native-svg'

import { Text } from '../Typography'

const Container = styled(View)`
  height: ${props => props.height}px;
  paddingVertical: 16px;
`

const LabelNameContainer = styled(View)`
  position: absolute;
  bottom: -17px;
  left: -35px;
`

export default class _BarChart extends PureComponent {
  render () {
    let {
      formatValue = (item) => { return item },
      values,
      activeColour = '#71bbcd',
      colour = '#71bbcd',
      height = 200,
      width,
      labelName,
      yMin
    } = this.props

    width = width || height
    const data = values.map(v => ({
      label: v.label,
      value: v.value,
      svg: { fill: v.active ? activeColour : colour }
    }))

    const xlabels = values.map(v => v.label)

    const inset = width / data.length / 2
    const maxVal = Math.max(...values.map(v => v.value))
    const CUT_OFF = maxVal / 50 * 45

    const Labels = ({ x, y, bandwidth, data }) => (
      data.map(({ value }, index) => (
        <Svg.Text
          key={index}
          x={x(index) + (bandwidth / 2)}
          y={value < CUT_OFF ? y(value) - 10 : y(value) + 15}
          fontSize={14}
          fill={value >= CUT_OFF ? 'white' : 'black'}
          alignmentBaseline='middle'
          textAnchor='middle'
          fontFamily={Platform.select({ web: 'ubuntu-medium' })}
        >
          {formatValue(value)}
        </Svg.Text>
      ))
    )

    return (
      <Container height={height}>
        <BarChart
          style={{ height: height - 20, width }}
          data={data}
          svg={{ fill: 'rgba(134, 65, 244, 0.8)' }}
          contentInset={{ top: 10, bottom: 10 }}
          spacing={0.2}
          gridMin={0}
          yAccessor={(d) => d.item.value}
          yMin={yMin}
          yMax={maxVal}
        >
          <Labels />
        </BarChart>
        <XAxis
          style={{ marginTop: 10, height: 20, width }}
          data={xlabels}
          formatLabel={(value, index) => value}
          contentInset={{ left: inset, right: inset }}
          svg={{
            fontFamily: Platform.select({ web: 'ubuntu-bold' }), // TODO fontFamily fix
            fontSize: 14,
            fill: '#888888'
          }}
        />
        {labelName &&
          <LabelNameContainer>
            <Text overrides={{ fontFamily: 'ubuntu-medium', fontSize: 14, color: '#888888' }}>{labelName}</Text>
          </LabelNameContainer>}
      </Container>
    )
  }
}
